module.exports = __webpack_public_path__ + "img/favorite.40f0e995.svg";